// This file is automatically generated. Do not edit manually.

import { ReclamationCreationService_CreateRequest } from "src/api/generated/erp/reclamations/service/reclamationCreationService";
import { ReclamationUpdateService_UpdateRequest } from "src/api/generated/erp/reclamations/service/reclamationUpdateService";
import { CostEventPriceListView } from "src/api/generated/erp/db/types/tables/costEventPriceListView";
import { CustomerOrderView } from "src/api/generated/erp/db/types/tables/customerOrderView";
import { Reclamation } from "src/api/generated/erp/db/types/tables/reclamation";
import { ReclamationCategory } from "src/api/generated/erp/db/types/tables/reclamationCategory";
import { ReclamationCause } from "src/api/generated/erp/db/types/tables/reclamationCause";
import { ReclamationHandlingMethod } from "src/api/generated/erp/db/types/tables/reclamationHandlingMethod";
import { ReclamationLocation } from "src/api/generated/erp/db/types/tables/reclamationLocation";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ReclamationEditApi {
	export async function getInitData(args: {
		reclamationId: number | null | undefined;
		customerOrderId?: number | null | undefined;
	}): Promise<ReclamationEditApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/ReclamationForm/getInitData",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
				customerOrderId: args.customerOrderId,
			},
		});
		return response as ReclamationEditApi_InitData;
	}

	export async function insert(args: {
		reclamation: ReclamationCreationService_CreateRequest;
		customerOrderId: number | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/ReclamationForm/insert",
			method: "POST",
			data: {
				reclamation: args.reclamation,
				customerOrderId: args.customerOrderId,
			},
		});
		return response as number;
	}

	export async function update(args: { reclamation: ReclamationUpdateService_UpdateRequest }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/ReclamationForm/update",
			method: "POST",
			data: {
				reclamation: args.reclamation,
			},
		});
		return response as number;
	}

	export async function delete_(args: { reclamationId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/ReclamationForm/delete",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
			},
		});
		return response as void;
	}
}

export interface ReclamationEditApi_InitData {
	costEventPriceLists: Array<CostEventPriceListView>;
	customerOrder: CustomerOrderView | null | undefined;
	defaultCostEventPriceListId: number | null | undefined;
	reclamation: Reclamation | null | undefined;
	reclamationCategories: Array<ReclamationCategory>;
	reclamationCauses: Array<ReclamationCause>;
	reclamationHandlingMethods: Array<ReclamationHandlingMethod>;
	reclamationLocations: Array<ReclamationLocation>;
}
